<div class="container-fluid h-100">
    <div class="row h-100">
        <div class="p-1" style="height: 100%; overflow: hidden; flex :0 0 100%">
            <div class="" *ngFor="let item of vertical_tabs">
                <div style="max-height: calc(100vh - 165px);overflow-y: auto;"
                    *ngIf="item.id==1 && item.active &&item.visible">
                    <tm-dynamic-form-v2 [sections]="sections" [verification_status_list]="verification_status_list"
                        (fieldClick)="cellClicked($event)" [extra_data]="{alertId : alertId}"
                        [form_group]="onboarding_form" (dataSaved)="dataSaved($event)" [display_type]="2">
                    </tm-dynamic-form-v2>
                </div>

            </div>

        </div>
    </div>
</div>

<ng-template #transaction_history_temp let-transaction="transaction">
    <!-- <div
      *ngIf="(req_id != transaction.requirement_id && requirement_details && requirement_details.req_res_id) || !(requirement_details && requirement_details.req_res_id)"
      (click)="updateResumeManager(transaction)" class="view">
      View
    </div> -->
    <div class="d-table w-100">
        <div class="summary-item" title=" {{ 'Job title' | translate }} ">
            <div class="summary-item-icon">
                <i class="fa fa-briefcase"></i>
            </div>
            <div class="summary-item-details requirement-tab-link pointer " (click)="openRequirementTab(transaction)">
                {{transaction.productName}}
            </div>
        </div>
        <div *ngIf="transaction.productCodeText && transaction.productCodeText !=''" class="mt-1 summary-item"
            title=" {{ 'Job code' | translate }} ">
            <div class="summary-item-icon">
                <i class="fa fa-ticket"></i>
            </div>
            <div class="summary-item-details requirement-tab-link pointer " (click)="openRequirementTab(transaction)">
                {{transaction.productCodeText}}
            </div>
        </div>
        <div class="mt-1 summary-item"
            *ngIf="transaction && transaction.publishingTypeTitle &&transaction.publishingTypeTitle !='' "
            title=" {{ 'Publishing type' | translate }} ">
            <div class="summary-item-icon">
                <i class="fa fa-newspaper-o" aria-hidden="true"></i>
            </div>
            <div class="summary-item-details ">
                {{transaction.publishingTypeTitle}}
            </div>
        </div>
        <div class="summary-item" title=" {{ 'Status' | translate }} ">
            <div class="summary-item-icon">
                <i class="fa fa-info-circle"></i>
            </div>
            <div class="summary-item-details">
                <div class="d-flex" *ngIf="transaction.stageTitle && transaction.stageTitle != ''">
                    <div [ngStyle]="{'flex':'0 0 100%' }">
                        <span *ngIf="transaction.stageTitle && transaction.stageTitle != ''">
                            {{transaction.stageTitle}}
                        </span>
                        <span *ngIf="transaction.statusTitle && transaction.statusTitle != ''">
                            ({{transaction.statusTitle}})
                        </span>
                    </div>
                    <!-- <div *ngIf="(req_id != transaction.requirement_id && requirement_details && requirement_details.req_res_id) || !(requirement_details && requirement_details.req_res_id)"
                          class="m-auto text-center" style="flex: 0 0 30%;">
                          <span class="switch-transaction" (click)="updateResumeManager(transaction)">
                              View
                          </span>
                      </div> -->
                </div>
                <div class="d-flex"
                    *ngIf="(!transaction.stageTitle || transaction.stageTitle == '') &&transaction.statusTitle && transaction.statusTitle != ''">
                    <div [ngStyle]="{'flex':'0 0 100%' }">
                        <span *ngIf="transaction.statusTitle && transaction.statusTitle != ''">
                            {{transaction.statusTitle}}
                        </span>
                    </div>
                    <!-- <div *ngIf="(req_id != transaction.requirement_id && requirement_details && requirement_details.req_res_id) || !(requirement_details && requirement_details.req_res_id)"
                          class="m-auto text-center" style="flex: 0 0 30%;">
                          <span class="switch-transaction" (click)="updateResumeManager(transaction)">
                              View
                          </span>
                      </div> -->
                </div>
            </div>
        </div>

        <div class="mt-1 summary-item" *ngIf="transaction && transaction.employerName && transaction.employerName !='' "
            title=" {{ 'Employer name' | translate }} ">
            <div class="summary-item-icon">
                <i class="fa fa-building-o" aria-hidden="true"></i>
            </div>
            <div class="summary-item-details ">
                {{transaction.employerName}}
            </div>
        </div>
    </div>
    <div *ngIf="transaction.createdBy || transaction.crDate" class="mt-1" style="font-size: 10px;">
        Created
        <span *ngIf="transaction.createdBy">
            by
            {{transaction.createdBy}}
        </span>
        <span *ngIf="transaction.crDate">
            on
            {{transaction.crDate | UtcToLocalTime | date: 'd-MMM-yyyy h:mm a'}}
        </span>
    </div>
    <div *ngIf="transaction.updatedBy || transaction.luDate" class="mt-1" style="font-size: 10px;">
        Updated
        <span *ngIf="transaction.updatedBy">
            by
            {{transaction.updatedBy}}
        </span>
        <span *ngIf="transaction.luDate">
            on
            {{transaction.luDate | UtcToLocalTime | date: 'd-MMM-yyyy h:mm a'}}
        </span>
    </div>
</ng-template>

<ng-template #applicant_summary_temp let-transaction="transaction">
    <!-- <div
      *ngIf="(req_id != transaction.requirement_id && requirement_details && requirement_details.req_res_id) || !(requirement_details && requirement_details.req_res_id)"
      (click)="updateResumeManager(transaction)" class="view">
      View
    </div> -->
    <div class="d-table w-100">
        <div class="summary-item" title=" {{ 'Job title' | translate }} ">
            <div class="summary-item-icon">
                <i class="fa fa-user"></i>
            </div>
            <div class="summary-item-details requirement-tab-link pointer " (click)="openRequirementTab(transaction)">
                {{transaction.firstName}} {{transaction.lastName}}
            </div>
        </div>

        <!-- <div class="summary-item" title=" {{ 'Job title' | translate }} ">
        <div class="summary-item-icon">
          <i class="fa fa-tag"></i>
        </div>
        <div class="summary-item-details requirement-tab-link pointer " (click)="openRequirementTab(transaction)">
          {{transaction.productName}}
        </div>
      </div> -->
        <div *ngIf="transaction.emailId && transaction.emailId !=''" class="mt-1 summary-item"
            title=" {{ 'Email ID' | translate }} ">
            <div class="summary-item-icon">
                <i class="fa fa-envelope"></i>
            </div>
            <div class="summary-item-details requirement-tab-link pointer ">
                {{transaction.emailId}}
            </div>
        </div>
        <div *ngIf="transaction.mobileNumber && transaction.mobileNumber !=''" class="mt-1 summary-item"
            title=" {{ 'Mobile number' | translate }} ">
            <div class="summary-item-icon">
                <i class="fa fa-phone"></i>
            </div>
            <div class="summary-item-details requirement-tab-link pointer link " (click)="dial(transaction)">
                {{transaction.mobileNumber}}
            </div>
        </div>
        <div class="summary-item" title=" {{ 'Status' | translate }} ">
            <div class="summary-item-icon">
                <i class="fa fa-info-circle"></i>
            </div>
            <div class="summary-item-details">
                <div class="d-flex" *ngIf="transaction.stageTitle && transaction.stageTitle != ''">
                    <div [ngStyle]="{'flex':'0 0 100%' }">
                        <span *ngIf="transaction.stageTitle && transaction.stageTitle != ''">
                            {{transaction.stageTitle}}
                        </span>
                        <span *ngIf="transaction.statusTitle && transaction.statusTitle != ''">
                            ({{transaction.statusTitle}})
                        </span>
                    </div>
                    <!-- <div *ngIf="(req_id != transaction.requirement_id && requirement_details && requirement_details.req_res_id) || !(requirement_details && requirement_details.req_res_id)"
                          class="m-auto text-center" style="flex: 0 0 30%;">
                          <span class="switch-transaction" (click)="updateResumeManager(transaction)">
                              View
                          </span>
                      </div> -->
                </div>
                <div class="d-flex"
                    *ngIf="(!transaction.stageTitle || transaction.stageTitle == '') &&transaction.statusTitle && transaction.statusTitle != ''">
                    <div [ngStyle]="{'flex':'0 0 100%' }">
                        <span *ngIf="transaction.statusTitle && transaction.statusTitle != ''">
                            {{transaction.statusTitle}}
                        </span>
                    </div>
                    <!-- <div *ngIf="(req_id != transaction.requirement_id && requirement_details && requirement_details.req_res_id) || !(requirement_details && requirement_details.req_res_id)"
                          class="m-auto text-center" style="flex: 0 0 30%;">
                          <span class="switch-transaction" (click)="updateResumeManager(transaction)">
                              View
                          </span>
                      </div> -->
                </div>
            </div>
        </div>

        <div class="mt-1 summary-item" *ngIf="transaction && transaction.employerName && transaction.employerName !='' "
            title=" {{ 'Employer name' | translate }} ">
            <div class="summary-item-icon">
                <i class="fa fa-building-o" aria-hidden="true"></i>
            </div>
            <div class="summary-item-details ">
                {{transaction.employerName}}
            </div>
        </div>
    </div>
    <div *ngIf="transaction.createdBy || transaction.crDate" class="mt-1" style="font-size: 10px;">
        Created
        <span *ngIf="transaction.createdBy">
            by
            {{transaction.createdBy}}
        </span>
        <span *ngIf="transaction.crDate">
            on
            {{transaction.crDate | UtcToLocalTime | date: 'd-MMM-yyyy h:mm a'}}
        </span>
    </div>
    <div *ngIf="transaction.updatedBy || transaction.luDate" class="mt-1" style="font-size: 10px;">
        Updated
        <span *ngIf="transaction.updatedBy">
            by
            {{transaction.updatedBy}}
        </span>
        <span *ngIf="transaction.luDate">
            on
            {{transaction.luDate | UtcToLocalTime | date: 'd-MMM-yyyy h:mm a'}}
        </span>
    </div>
</ng-template>
